import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './loadingStyled';

export default function IsLoading({ isLoading, cancelar }) {
  const limparLocalStorage = () => {
    localStorage.clear();
    // eslint-disable-next-line no-restricted-globals
    location.reload(true);
  };

  if (!isLoading) return <> </>;

  return (
    <Container>
      <div />
      <span>
        <i className="pi pi-spin pi-spinner" style={{ fontSize: '1em' }}></i>
        Carregando...
      </span>
      {(cancelar) ? (
        <div className="pull-left">
          <br />
          <button
            // style={{ position:relative, top: '15px'}}
            onClick={limparLocalStorage}
            type="button"
            className="btn btn-danger"
          >
            Cancelar
          </button>
        </div>
      ) : ('')}
    </Container>
  );
}

IsLoading.defaultProps = {
  isLoading: false,
};

IsLoading.propTypes = {
  isLoading: PropTypes.bool,
};
